
// @ts-nocheck


export const localeCodes =  [
  "it",
  "en",
  "de"
]

export const localeLoaders = {
  "it": [],
  "en": [],
  "de": []
}

export const vueI18nConfigs = [
  () => import("../i18n/i18n.config.ts?hash=5b32d2e0&config=1" /* webpackChunkName: "__i18n_i18n_config_5b32d2e0" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n/i18n.config",
  "locales": [
    {
      "code": "it",
      "site": "it",
      "language": "it-IT",
      "name": "Italiano"
    },
    {
      "code": "en",
      "site": "en",
      "language": "en-GB",
      "name": "English"
    },
    {
      "code": "de",
      "site": "de",
      "language": "de-DE",
      "name": "Deutsch"
    }
  ],
  "defaultLocale": "it",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://www.osteriaallaterrazza.it",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "menu/index": {
      "it": "/menu",
      "en": "/menu",
      "de": "/menu"
    },
    "carta-vini/index": {
      "it": "/carta-vini",
      "en": "/wine-list",
      "de": "/weinkarte"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "it",
    "site": "it",
    "language": "it-IT",
    "name": "Italiano",
    "files": []
  },
  {
    "code": "en",
    "site": "en",
    "language": "en-GB",
    "name": "English",
    "files": []
  },
  {
    "code": "de",
    "site": "de",
    "language": "de-DE",
    "name": "Deutsch",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
